let pending: File[] = [];
let selected: File[] = [];

export function setPendingFiles(files: File[]): void {
  pending = files.slice();
}

export function takePendingFiles(): File[] {
  const out = pending;
  pending = [];
  return out;
}

export function peekPendingFiles(): File[] {
  return pending.slice();
}

export function setSelectedFiles(files: File[]): void {
  selected = files.slice();
}

export function peekSelectedFiles(): File[] {
  return selected.slice();
}

export function clearSelectedFiles(): void {
  selected = [];
}

export type FileKind = 'pdf' | 'image' | 'docx' | 'xlsx' | 'csv' | 'unknown';

export function detectKind(file: File): FileKind {
  const name = file.name.toLowerCase();
  const mime = file.type;
  if (mime === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
  if (mime.startsWith('image/jpeg') || mime.startsWith('image/png') || /\.(jpe?g|png)$/i.test(name)) return 'image';
  if (name.endsWith('.docx')) return 'docx';
  if (name.endsWith('.xlsx')) return 'xlsx';
  if (name.endsWith('.csv') || name.endsWith('.tsv') || mime === 'text/csv' || mime === 'text/tab-separated-values' || mime === 'text/plain') return 'csv';
  return 'unknown';
}

export type SmartRoute =
  | { kind: 'route'; toolId: string }
  | { kind: 'choose-pdf-action'; file: File }
  | { kind: 'unsupported'; details: string };

export function routeFiles(files: File[]): SmartRoute {
  if (!files.length) return { kind: 'unsupported', details: 'Файлов нет' };
  const kinds = files.map(detectKind);
  const unique = new Set(kinds);

  if (unique.size === 1) {
    const k = kinds[0];
    if (k === 'pdf' && files.length === 1) return { kind: 'choose-pdf-action', file: files[0] };
    if (k === 'pdf' && files.length > 1) return { kind: 'route', toolId: 'merge' };
    if (k === 'image') return { kind: 'route', toolId: 'jpg-to-pdf' };
    if (k === 'docx') return { kind: 'route', toolId: 'docx-to-pdf' };
    if (k === 'xlsx') return { kind: 'route', toolId: 'xlsx-to-pdf' };
    if (k === 'csv') return { kind: 'route', toolId: 'csv-to-pdf' };
  }
  return {
    kind: 'unsupported',
    details: `Не знаю что делать с набором: ${[...unique].join(', ')}. Используйте отдельный инструмент.`,
  };
}
